import { usePageMeta } from '../lib/usePageMeta'
import { Link } from 'react-router'
import { SearchX } from 'lucide-react'

import { EmptyState } from '../components/EmptyState'
import { useI18n } from '../i18n/context'

export function NotFoundPage() {
  const { t } = useI18n()
  usePageMeta({ title: t('notFound.title'), noindex: true })
  return (
    <div className="center-state">
      <EmptyState
        icon={<SearchX size={26} />}
        title={t('notFound.title')}
        action={
          <Link to="/" className="btn btn-primary">
            {t('notFound.back')}
          </Link>
        }
      />
    </div>
  )
}
